<template>

    <div class="toggle-view">
        <a 
            :class="currentActive == 1 ? 'active' : null" 
            href=""
            @click="clickEvent($event, 'data-view')"
            >
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path fill-rule="evenodd" clip-rule="evenodd" d="M8.00024 19.0079H22V17.008H8.00024V19.0079ZM8.00024 13.0023H22V11.0023H8.00024V13.0023ZM8.00024 7.00229H22V5.00231H8.00024V7.00229ZM4.00161 16C2.89645 16 2.0011 16.896 2.0011 18C2.0011 19.104 2.89645 20 4.00041 20C5.10437 20 6.00088 19.104 6.00088 18C6.00088 16.896 5.10437 16 4.00041 16H4.00161ZM4.00166 9.99999C2.89536 9.99999 2 10.896 2 12C2 13.104 2.89536 14 3.99931 14C5.10323 14 6.00093 13.104 6.00093 12C6.00093 10.896 5.10323 9.99999 4.00046 9.99999H4.00166ZM4.00166 4C2.89536 4 2 4.89601 2 6.00003C2 7.104 2.89651 8.00001 4.00046 8.00001C5.10442 8.00001 6.00093 7.104 6.00093 6.00003C6.00093 4.89601 5.10323 4 4.00046 4H4.00166Z" fill="#1F2328"></path>
            </svg>
        </a>
        <a 
            :class="currentActive == 1 ? 'active' : null" 
            href="" 
            @click="clickEvent($event, 'board')"
            >
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" transform="rotate(180)">
                <path fill-rule="evenodd" clip-rule="evenodd" d="M7.88236 21H10.2353V3H7.88236V21ZM13.7648 21H16.1177V7.50003H13.7648V21ZM2.00002 21H4.35298V10.875H2.00002V21ZM19.647 21H22V13.125H19.647V21Z" fill="#1F2328"></path>
            </svg>
        </a>

        <a
            :class="currentActive == 1 ? 'active' : null" 
            href=""
            @click="clickEvent($event, 'calendar')"
            >
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path fill-rule="evenodd" clip-rule="evenodd" d="M20.4059 19.48C20.4006 20.3393 19.8035 20.4815 19.4547 20.4895C19.4547 20.4895 5.20768 20.492 4.5894 20.4925C4.30939 20.4925 4.08742 20.4182 3.92889 20.2709C3.70168 20.0553 3.58534 19.6529 3.58534 19.1112V10.0001H20.4112C20.4112 13.4079 20.4164 18.2751 20.4059 19.48ZM3.58534 6.54501C3.58534 5.75662 3.9024 5.41895 4.64757 5.4149H6.1695V6.52238C6.1695 6.93846 6.52352 7.27613 6.96214 7.27613C7.39554 7.27613 7.75488 6.93846 7.75488 6.52238V5.41443H8.82757H16.1202V6.52238C16.1202 6.93846 16.4742 7.27613 16.9129 7.27613C17.3514 7.27613 17.7055 6.93846 17.7055 6.52238V5.41443C18.6619 5.41443 19.275 5.4149 19.2962 5.4149C19.6819 5.42696 19.9567 5.52045 20.1311 5.70233C20.3795 5.95558 20.4164 6.36663 20.4112 6.49575V6.5465V8.49267H3.58534V6.54552V6.54501ZM21.9966 6.56409C22.0018 6.35605 22.0018 5.41996 21.3148 4.69685C20.9872 4.35466 20.3847 3.94063 19.3226 3.90743H17.7055V2.75375C17.7055 2.33716 17.3514 2 16.9129 2C16.4742 2 16.1202 2.33716 16.1202 2.75375V3.90743H7.75488V2.75375C7.75488 2.33716 7.39554 2 6.96215 2C6.52352 2 6.1695 2.33716 6.1695 2.75375V3.90743H4.64225C3.36337 3.9145 1.99474 4.61141 2.00002 6.54649C2.00002 6.67114 2.00534 18.3449 2.00002 19.1077C2.00002 20.0755 2.26951 20.8257 2.80854 21.3372C3.26829 21.7709 3.88129 22 4.58413 22H4.58941C5.21301 21.9995 19.4547 21.997 19.4494 21.997H19.4547C20.4693 21.997 21.9806 21.3297 21.9912 19.4896C22.0071 17.6299 21.9966 7.08317 21.9966 6.56409Z" fill="black"></path>
            </svg>
        </a>
    </div>
</template>


<script>
export default {
    name: 'ViewWrapperToggle',
    data() {
        return {
            currentActive: 1
        }
    },
    emits: ['wrapper-toggle-update'],
    methods: {

        clickEvent(e, target) {
        
            e.preventDefault()
            const a = e.currentTarget
            // $('.toggle-view a').removeClass('active')
            this.currentActive = [...a.parentNode.children].indexOf(a) + 1;
            this.$emit('wrapper-toggle-update', {
                target
            })

            this.emitter.emit('wrapper-toggle-update', {
                target
            })

            //TODO Continue here        

        }
    }
}    
</script>